import React from "react";
import Sidebar from "./../components/sidebar";
import Header from "./../components/Header";
import AddFaqMain from "../components/faqs/AddFaqMain";

const AddFaq = () => {
    return (
        <>
            <Sidebar />
            <main className="main-wrap">
                <Header />
                <AddFaqMain />
            </main>
        </>
    );
};

export default AddFaq;